import Vue from "vue";
import Selected from "../store/modules/selected";
import ProcessFlow from "~/models/processFlows/processFlow";
import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import routerMixin from '~/mixins/routerMixin'
import {IOrganization} from '~/interfaces/organizationInterfaces'

export default Vue.extend({
  mixins: [
    routerMixin,
  ],
  computed: {
    selectedProcessFlow(): ProcessFlow {
      return Selected.processFlow.get();
    },
    selectedStep: {
      get(): ProcessFlowStep {
        return Selected.step.get();
      },
      set(step: ProcessFlowStep): void {
        Selected.step.set(step)
        this.appendQuery({ stepId: step.client_id }, { mode: 'replace' })
      }
    },
    selectedOrganization(): IOrganization {
      return Selected.organization.get();
    },
  },
});